import'./style.scss'
import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { AbsoluteContainer, AppSpan, FixedContainer, FlexColumn, FlexRow } from "src/style"
import { AppCenterPopupD3, DecisionBox } from "src/component"
import {ReactComponent as TopBgIcon} from 'src/assets/img/sidemenu-bg-top-icon.svg'
import {ReactComponent as BottomBgIcon} from 'src/assets/img/sidemenu-bg-bottom-icon.svg'
import SideMenuData from './sidemenu-data'
import Menu from './menu'
import { Features } from 'src/model'

export const SideMenuD3: React.FC<any> = ({setLogout, close}) => {
    const navigate = useNavigate()
    const {info: {institutionData}} = useContext(AppInfoContext)

    function handleClick(item: any) {
        if (item.title === 'Logout') setLogout()
        else navigate(item.path)
        close()
    }
   
    return (
        <>
            <AppCenterPopupD3 
                isCustomContent={true}
                overlayBgColor='rgba(0, 0, 0, 0.07)'
                zIndex='4'
                close={close}
            >
                <FixedContainer 
                    top="10" left="1" width="64.8"
                    maxWidth="95" data-aos="slide-right"
                    className="sidemenu-d2-container"
                    onClick={(e) => e.stopPropagation()}
                >
                    <FlexRow 
                        minHeight="23.5" gap="2.5" wrap='wrap'
                        radius="1" bgColor='#1A2C37' alignItems='flex-start'
                        padding="3" leftPadding='5' rightPadding='5'
                        className='sidemenu-d2-flex'
                    >
                        <AbsoluteContainer top='0' right='0'>
                            <TopBgIcon />
                        </AbsoluteContainer>
                        <AbsoluteContainer bottom='0' left='0'>
                            <BottomBgIcon />
                        </AbsoluteContainer>
                        {
                            SideMenuData.map((item, index) => {
                                return (
                                    (
                                        (item.title === 'Investment' && (!institutionData.featureIDs?.includes(Features.FIXED_DEPOSIT) && !institutionData.featureIDs?.includes(Features.TARGET_SAVINGS)))
                                        // || (item.title === 'Borrow' && !institutionData.featureIDs?.includes(Features.RECOVA_LOAN))
                                    ) ?
                                    null
                                    :
                                    <Menu 
                                        key={index} item={item} 
                                        setLogout={setLogout}
                                        handleClick={(data: any) => handleClick(data)}
                                    />
                                )
                            })
                        }
                    </FlexRow>
                </FixedContainer>
            </AppCenterPopupD3>
        </>
    )
}